// export const base_path = "/react/template/";
export const base_path = "/";
export const image_path = "https://m.media-amazon.com/images/I/";
